import { DateTime } from "luxon";

import { formatLastUpdatedText } from "@intelligems/ig-utils/date-time";

export const formatAnalyticsSummaryTimestamp = (timestamp: string) => {
  const now = DateTime.now();
  const lastUpdated = DateTime.fromISO(timestamp);

  return formatLastUpdatedText(lastUpdated.toMillis(), {
    fallback: (ts) =>
      `on ${DateTime.fromMillis(ts).toLocaleString({
        dateStyle: "short",
        timeStyle: "short",
      })}`,
    maxRelativeAgeMs: 24 * 3_600_000,
    now: now.toMillis(),
    prefix: "Last updated ",
  });
};
